

















// import React, { useState, useEffect } from 'react';
// import { toast } from 'sonner';
// import { css } from '@emotion/react';
// import { ClipLoader } from 'react-spinners';
// import { Bar, Pie } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   CategoryScale,
//   LinearScale,
//   BarElement,
// } from 'chart.js';
// import { FaEye, FaSort, FaSortUp, FaSortDown, FaTimes, FaUserCircle } from 'react-icons/fa';
// import axios from "axios";
// import AdminActions from './AdminActions';

// ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

// const override = css`display: block; margin: 0 auto;`;

// const JobSeekerTable = () => {
//   const [jobSeekers, setJobSeekers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');           // Name / Email search
//   const [minSalaryFilter, setMinSalaryFilter] = useState(''); // Minimum Salary >= 
//   const [leastSalaryFilter, setLeastSalaryFilter] = useState(''); // Least Salary >= 
//   const [activeFilter, setActiveFilter] = useState('All');
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
//   const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

//   useEffect(() => {
//     const fetchJobSeekers = async () => {
//       try {
//         const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
//         });
//         setJobSeekers(response.data || []);
//       } catch (error) {
//         console.error('Fetch Error:', error);
//         toast.error('Failed to fetch job seekers');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobSeekers();
//   }, []);

//   // Time-based filtering
//   const now = new Date();
//   const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
//   const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
//   const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
//   const startOfYear = new Date(now.getFullYear(), 0, 1);

//   const todaySeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfToday);
//   const weekSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfWeek);
//   const monthSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfMonth);
//   const yearSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfYear);

//   const getTimeFiltered = () => {
//     switch (activeFilter) {
//       case 'Today': return todaySeekers;
//       case 'Week': return weekSeekers;
//       case 'Month': return monthSeekers;
//       case 'Year': return yearSeekers;
//       default: return jobSeekers;
//     }
//   };

//   // Main filtering (Name + Salary ranges)
//   let filteredJobSeekers = getTimeFiltered().filter(js => {
//     const nameMatch = `${js.firstName || ''} ${js.lastName || ''} ${js.email || ''}`
//       .toLowerCase()
//       .includes(searchTerm.toLowerCase());

//     const minSalaryMatch = !minSalaryFilter || 
//       (parseFloat(js.minimumSalary || 0) >= parseFloat(minSalaryFilter));

//     const leastSalaryMatch = !leastSalaryFilter || 
//       (parseFloat(js.leastSalary || 0) >= parseFloat(leastSalaryFilter));

//     return nameMatch && minSalaryMatch && leastSalaryMatch;
//   });

//   // Sorting Logic (Minimum & Least Salary)
//   if (sortConfig.key) {
//     filteredJobSeekers = [...filteredJobSeekers].sort((a, b) => {
//       let valA = a[sortConfig.key];
//       let valB = b[sortConfig.key];

//       if (sortConfig.key === 'minimumSalary' || sortConfig.key === 'leastSalary') {
//         valA = parseFloat(valA) || 0;
//         valB = parseFloat(valB) || 0;
//       }

//       if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
//       if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
//       return 0;
//     });
//   }

//   const handleSort = (key) => {
//     setSortConfig(prev => ({
//       key,
//       direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
//     }));
//   };

//   const getSortIcon = (key) => {
//     if (sortConfig.key !== key) return <FaSort className="inline ml-1 text-gray-500" />;
//     return sortConfig.direction === 'asc' 
//       ? <FaSortUp className="inline ml-1 text-orange-500" /> 
//       : <FaSortDown className="inline ml-1 text-orange-500" />;
//   };

//   // Charts (unchanged)
//   const salaryData = {
//     labels: ['Below 50k', '50k-100k', '100k-200k', 'Above 200k'],
//     datasets: [{
//       label: 'Minimum Salary',
//       data: [
//         jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) <= 50000).length,
//         jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 50000 && parseFloat(js.minimumSalary || 0) <= 100000).length,
//         jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 100000 && parseFloat(js.minimumSalary || 0) <= 200000).length,
//         jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 200000).length,
//       ],
//       backgroundColor: '#f97316',
//     }],
//   };

//   const statusPieData = {
//     labels: ['Verified', 'Not Verified', 'Blacklisted'],
//     datasets: [{
//       data: [
//         jobSeekers.filter(js => js.isVerified).length,
//         jobSeekers.filter(js => !js.isVerified).length,
//         jobSeekers.filter(js => js.isBlacklisted).length,
//       ],
//       backgroundColor: ['#22c55e', '#eab308', '#ef4444'],
//     }],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: { legend: { position: 'bottom', labels: { color: '#ddd' } } },
//   };

//   if (loading) {
//     return <div className="flex items-center justify-center h-screen bg-gray-950"><ClipLoader color="#f97316" css={override} size={60} /></div>;
//   }

//   return (
//     <div className="p-4 md:p-6 bg-gray-950 min-h-screen text-white">
//       <h1 className="text-4xl font-bold mb-8 text-orange-500">Job Seekers Management</h1>

//       {/* Time Filters */}
//       <div className="flex flex-wrap gap-3 mb-6">
//         {[
//           { label: 'All', value: 'All', count: jobSeekers.length },
//           { label: 'Today', value: 'Today', count: todaySeekers.length },
//           { label: 'This Week', value: 'Week', count: weekSeekers.length },
//           { label: 'This Month', value: 'Month', count: monthSeekers.length },
//           { label: 'This Year', value: 'Year', count: yearSeekers.length },
//         ].map((f) => (
//           <button
//             key={f.value}
//             onClick={() => setActiveFilter(f.value)}
//             className={`px-6 py-3 rounded-2xl font-medium transition-all ${activeFilter === f.value ? 'bg-orange-600 text-white' : 'bg-gray-900 border border-gray-700 hover:border-orange-500'}`}
//           >
//             {f.label} ({f.count})
//           </button>
//         ))}
//       </div>

//       {/* Search & Salary Filters */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
//         <input
//           type="text"
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//           placeholder="Search by name or email..."
//           className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
//         />

//         <input
//           type="number"
//           value={minSalaryFilter}
//           onChange={(e) => setMinSalaryFilter(e.target.value)}
//           placeholder="Min Salary ≥ (e.g. 50000)"
//           className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
//         />

//         <input
//           type="number"
//           value={leastSalaryFilter}
//           onChange={(e) => setLeastSalaryFilter(e.target.value)}
//           placeholder="Least Salary ≥ (e.g. 30000)"
//           className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
//         />
//       </div>

//       {/* Charts */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-10">
//         <div className="bg-gray-900 border border-gray-800 rounded-3xl p-6">
//           <h2 className="text-xl font-semibold mb-4 text-orange-400">Minimum Salary Distribution</h2>
//           <div className="h-80"><Bar data={salaryData} options={chartOptions} /></div>
//         </div>
//         <div className="bg-gray-900 border border-gray-800 rounded-3xl p-6">
//           <h2 className="text-xl font-semibold mb-4 text-orange-400">Verification Status</h2>
//           <div className="h-80"><Pie data={statusPieData} options={chartOptions} /></div>
//         </div>
//       </div>

//       {/* Table */}
//       <div className="bg-gray-900 border border-gray-800 rounded-3xl overflow-hidden">
//         <div className="p-6 border-b border-gray-800">
//           <h2 className="text-2xl font-semibold">
//             {activeFilter === 'All' ? 'All Job Seekers' : `${activeFilter} Job Seekers`} 
//             <span className="text-orange-500 ml-3">({filteredJobSeekers.length})</span>
//           </h2>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full min-w-[1100px]">
//             <thead>
//               <tr className="bg-gray-950 border-b border-gray-700">
//                 <th className="p-6 text-left">Full Name</th>
//                 <th className="p-6 text-left">Email</th>
//                 <th className="p-6 text-left cursor-pointer" onClick={() => handleSort('minimumSalary')}>
//                   Minimum Salary {getSortIcon('minimumSalary')}
//                 </th>
//                 <th className="p-6 text-left cursor-pointer" onClick={() => handleSort('leastSalary')}>
//                   Least Salary {getSortIcon('leastSalary')}
//                 </th>
//                 <th className="p-6 text-left">Phone</th>
//                 <th className="p-6 text-left">Location</th>
//                 <th className="p-6 text-left">Verified</th>
//                 <th className="p-6 text-left">Blacklisted</th>
//                 <th className="p-6 text-left">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredJobSeekers.map((js) => (
//                 <tr key={js._id} className="border-b border-gray-800 hover:bg-gray-800/70 transition-all">
//                   <td className="p-6 font-medium">{js.firstName} {js.lastName}</td>
//                   <td className="p-6 text-gray-400">{js.email || 'N/A'}</td>
//                   <td className="p-6 font-mono">₦{parseFloat(js.minimumSalary || 0).toLocaleString()}</td>
//                   <td className="p-6 font-mono">₦{parseFloat(js.leastSalary || 0).toLocaleString()}</td>
//                   <td className="p-6 text-gray-400">{js.phoneNumber || 'N/A'}</td>
//                   <td className="p-6 text-sm text-gray-400">{js.state} • {js.localGovernment}</td>
//                   <td className="p-6">
//                     <span className={`px-4 py-1 rounded-full text-xs ${js.isVerified ? 'bg-green-500/20 text-green-400' : 'bg-gray-700 text-gray-400'}`}>
//                       {js.isVerified ? 'Yes' : 'No'}
//                     </span>
//                   </td>
//                   <td className="p-6">
//                     <span className={`px-4 py-1 rounded-full text-xs ${js.isBlacklisted ? 'bg-red-500/20 text-red-400' : 'bg-gray-700 text-gray-400'}`}>
//                       {js.isBlacklisted ? 'Yes' : 'No'}
//                     </span>
//                   </td>
//                   <td className="p-6 flex gap-3">
//                     <button
//                       onClick={() => setSelectedJobSeeker(js)}
//                       className="flex items-center gap-2 bg-gray-800 hover:bg-orange-600 px-5 py-2 rounded-xl text-sm transition"
//                     >
//                       <FaEye /> View
//                     </button>
//                     {localStorage.getItem('userType') === 'admin' && <AdminActions jobSeekerId={js._id} isBlacklisted={js.isBlacklisted} />}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//          {/* ==================== DETAILED MODAL ==================== */}
//       {selectedJobSeeker && (
//         <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4 overflow-y-auto">
//           <div className="bg-gray-900 rounded-3xl max-w-4xl w-full max-h-[95vh] overflow-hidden border border-gray-700 shadow-2xl">
//             {/* Modal Header */}
//             <div className="flex items-center justify-between p-6 border-b border-gray-700 bg-gray-950 rounded-t-3xl">
//               <div className="flex items-center gap-4">
//                 {selectedJobSeeker.avatar ? (
//                   <img src={selectedJobSeeker.avatar} alt="Avatar" className="w-16 h-16 rounded-2xl object-cover border-2 border-orange-500" />
//                 ) : (
//                   <FaUserCircle className="w-16 h-16 text-gray-600" />
//                 )}
//                 <div>
//                   <h2 className="text-2xl font-bold">
//                     {selectedJobSeeker.firstName} {selectedJobSeeker.lastName}
//                   </h2>
//                   <p className="text-gray-400">{selectedJobSeeker.email}</p>
//                 </div>
//               </div>
//               <button
//                 onClick={() => setSelectedJobSeeker(null)}
//                 className="text-3xl text-gray-400 hover:text-white transition"
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             {/* Modal Content */}
//             <div className="p-8 overflow-y-auto max-h-[calc(95vh-80px)] grid grid-cols-1 md:grid-cols-2 gap-8">
//               {/* Personal Information */}
//               <div className="space-y-6">
//                 <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Personal Information</h3>
//                 <div className="grid grid-cols-2 gap-y-4 text-sm">
//                   <p><strong>Phone:</strong> {selectedJobSeeker.phoneNumber || 'N/A'}</p>
//                   <p><strong>Gender:</strong> {selectedJobSeeker.gender || 'N/A'}</p>
//                   <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || 'N/A'}</p>
//                   <p><strong>Marital Status:</strong> {selectedJobSeeker.maritalStatus || 'N/A'}</p>
//                   <p><strong>State:</strong> {selectedJobSeeker.state || 'N/A'}</p>
//                   <p><strong>LGA:</strong> {selectedJobSeeker.localGovernment || 'N/A'}</p>
//                   <p><strong>Country:</strong> {selectedJobSeeker.country || 'N/A'}</p>
//                   <p><strong>Address:</strong> {selectedJobSeeker.address || 'N/A'}</p>
//                 </div>
//               </div>

//               {/* Salary & Job Preferences */}
//               <div className="space-y-6">
//                 <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Salary & Job Preferences</h3>
//                 <div className="space-y-4">
//                   <div className="bg-gray-800 p-5 rounded-2xl">
//                     <p className="text-gray-400 text-sm">Minimum Salary Expected</p>
//                     <p className="text-3xl font-bold text-emerald-400">₦{parseFloat(selectedJobSeeker.minimumSalary || 0).toLocaleString()}</p>
//                   </div>
//                   <div className="bg-gray-800 p-5 rounded-2xl">
//                     <p className="text-gray-400 text-sm">Least Acceptable Salary</p>
//                     <p className="text-3xl font-bold text-orange-400">₦{parseFloat(selectedJobSeeker.leastSalary || 0).toLocaleString()}</p>
//                   </div>
//                 </div>
//               </div>

//               {/* Other Important Fields */}
//               <div className="md:col-span-2 space-y-6">
//                 <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Additional Information</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
//                   <div><strong>Is Verified:</strong> {selectedJobSeeker.isVerified ? 'Yes' : 'No'}</div>
//                   <div><strong>Blacklisted:</strong> {selectedJobSeeker.isBlacklisted ? 'Yes' : 'No'}</div>
//                   <div><strong>Account Balance:</strong> ₦{selectedJobSeeker.accountBalance?.toLocaleString() || 0}</div>
//                   <div><strong>NIN Verified:</strong> {selectedJobSeeker.isNINVerified ? 'Yes' : 'No'}</div>
//                   <div><strong>Availability for Urgent Work:</strong> {selectedJobSeeker.availabilityForUrgentWork ? 'Yes' : 'No'}</div>
//                   <div><strong>Last Login:</strong> {selectedJobSeeker.lastLogin ? new Date(selectedJobSeeker.lastLogin).toLocaleString() : 'Never'}</div>
//                 </div>
//               </div>
//             </div>

//             <div className="p-6 border-t border-gray-700 bg-gray-950 flex justify-end rounded-b-3xl">
//               <button
//                 onClick={() => setSelectedJobSeeker(null)}
//                 className="px-8 py-3 bg-gray-800 hover:bg-gray-700 rounded-2xl transition"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default JobSeekerTable;










import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import { Bar, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js';
import { FaEye, FaSort, FaSortUp, FaSortDown, FaTimes, FaUserCircle } from 'react-icons/fa';
import axios from "axios";
import AdminActions from './AdminActions';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const override = css`display: block; margin: 0 auto;`;

const JobSeekerTable = () => {
  const [jobSeekers, setJobSeekers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');           // Universal Search
  const [minSalaryFilter, setMinSalaryFilter] = useState(''); 
  const [leastSalaryFilter, setLeastSalaryFilter] = useState(''); 
  const [activeFilter, setActiveFilter] = useState('All');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [selectedJobSeeker, setSelectedJobSeeker] = useState(null);

  useEffect(() => {
    const fetchJobSeekers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}jobseeker/allJobSeeker`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setJobSeekers(response.data || []);
      } catch (error) {
        console.error('Fetch Error:', error);
        toast.error('Failed to fetch job seekers');
      } finally {
        setLoading(false);
      }
    };
    fetchJobSeekers();
  }, []);

  // Time-based filtering
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const startOfYear = new Date(now.getFullYear(), 0, 1);

  const todaySeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfToday);
  const weekSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfWeek);
  const monthSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfMonth);
  const yearSeekers = jobSeekers.filter(js => new Date(js.createdAt) >= startOfYear);

  const getTimeFiltered = () => {
    switch (activeFilter) {
      case 'Today': return todaySeekers;
      case 'Week': return weekSeekers;
      case 'Month': return monthSeekers;
      case 'Year': return yearSeekers;
      default: return jobSeekers;
    }
  };

  // ==================== UNIVERSAL SEARCH ====================
  const universalSearch = (js, term) => {
    if (!term) return true;

    const searchLower = term.toLowerCase().trim();

    const searchableFields = [
      js.firstName,
      js.lastName,
      js.middleName,
      js.email,
      js.phoneNumber,
      js.state,
      js.localGovernment,
      js.country,
      js.address,
      js.address2,
      js.gender,
      js.maritalStatus,
      js.educationLevel,
      js.race,
      js.dissability,
      js.jobMode,
      js.jobDecision,
      js.job,
      js.jobDecisionSalary,
      ...(js.jobChoice || []),
      ...(js.interestedJob || []),
    ];

    return searchableFields.some(field => 
      field && String(field).toLowerCase().includes(searchLower)
    );
  };

  // Main filtering (Universal Search + Salary ranges + Time Filter)
  let filteredJobSeekers = getTimeFiltered().filter(js => {
    const searchMatch = universalSearch(js, searchTerm);

    const minSalaryMatch = !minSalaryFilter || 
      (parseFloat(js.minimumSalary || 0) >= parseFloat(minSalaryFilter));

    const leastSalaryMatch = !leastSalaryFilter || 
      (parseFloat(js.leastSalary || 0) >= parseFloat(leastSalaryFilter));

    return searchMatch && minSalaryMatch && leastSalaryMatch;
  });

  // Sorting Logic
  if (sortConfig.key) {
    filteredJobSeekers = [...filteredJobSeekers].sort((a, b) => {
      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];

      if (sortConfig.key === 'minimumSalary' || sortConfig.key === 'leastSalary') {
        valA = parseFloat(valA) || 0;
        valB = parseFloat(valB) || 0;
      }

      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="inline ml-1 text-gray-500" />;
    return sortConfig.direction === 'asc' 
      ? <FaSortUp className="inline ml-1 text-orange-500" /> 
      : <FaSortDown className="inline ml-1 text-orange-500" />;
  };

  // Charts remain unchanged
  const salaryData = {
    labels: ['Below 50k', '50k-100k', '100k-200k', 'Above 200k'],
    datasets: [{
      label: 'Minimum Salary',
      data: [
        jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) <= 50000).length,
        jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 50000 && parseFloat(js.minimumSalary || 0) <= 100000).length,
        jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 100000 && parseFloat(js.minimumSalary || 0) <= 200000).length,
        jobSeekers.filter(js => parseFloat(js.minimumSalary || 0) > 200000).length,
      ],
      backgroundColor: '#f97316',
    }],
  };

  const statusPieData = {
    labels: ['Verified', 'Not Verified', 'Blacklisted'],
    datasets: [{
      data: [
        jobSeekers.filter(js => js.isVerified).length,
        jobSeekers.filter(js => !js.isVerified).length,
        jobSeekers.filter(js => js.isBlacklisted).length,
      ],
      backgroundColor: ['#22c55e', '#eab308', '#ef4444'],
    }],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { position: 'bottom', labels: { color: '#ddd' } } },
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen bg-gray-950"><ClipLoader color="#f97316" css={override} size={60} /></div>;
  }

  return (
    <div className="p-4 md:p-6 bg-gray-950 min-h-screen text-white">
      <h1 className="text-4xl font-bold mb-8 text-orange-500">Job Seekers Management</h1>

      {/* Time Filters - Unchanged */}
      <div className="flex flex-wrap gap-3 mb-6">
        {[
          { label: 'All', value: 'All', count: jobSeekers.length },
          { label: 'Today', value: 'Today', count: todaySeekers.length },
          { label: 'This Week', value: 'Week', count: weekSeekers.length },
          { label: 'This Month', value: 'Month', count: monthSeekers.length },
          { label: 'This Year', value: 'Year', count: yearSeekers.length },
        ].map((f) => (
          <button
            key={f.value}
            onClick={() => setActiveFilter(f.value)}
            className={`px-6 py-3 rounded-2xl font-medium transition-all ${activeFilter === f.value ? 'bg-orange-600 text-white' : 'bg-gray-900 border border-gray-700 hover:border-orange-500'}`}
          >
            {f.label} ({f.count})
          </button>
        ))}
      </div>

      {/* Search & Salary Filters */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by name, email, phone, location, job, education, etc..."
          className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
        />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search by  location,"
          className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
        />

        <input
          type="number"
          value={minSalaryFilter}
          onChange={(e) => setMinSalaryFilter(e.target.value)}
          placeholder="Min Salary ≥ (e.g. 50000)"
          className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
        />

        <input
          type="number"
          value={leastSalaryFilter}
          onChange={(e) => setLeastSalaryFilter(e.target.value)}
          placeholder="Least Salary ≥ (e.g. 30000)"
          className="p-4 bg-gray-900 border border-gray-700 rounded-2xl focus:border-orange-500 outline-none"
        />
      </div>

      {/* Charts - Unchanged */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-10">
        <div className="bg-gray-900 border border-gray-800 rounded-3xl p-6">
          <h2 className="text-xl font-semibold mb-4 text-orange-400">Minimum Salary Distribution</h2>
          <div className="h-80"><Bar data={salaryData} options={chartOptions} /></div>
        </div>
        <div className="bg-gray-900 border border-gray-800 rounded-3xl p-6">
          <h2 className="text-xl font-semibold mb-4 text-orange-400">Verification Status</h2>
          <div className="h-80"><Pie data={statusPieData} options={chartOptions} /></div>
        </div>
      </div>

      {/* Table - Unchanged except placeholder text */}
      <div className="bg-gray-900 border border-gray-800 rounded-3xl overflow-hidden">
        <div className="p-6 border-b border-gray-800">
          <h2 className="text-2xl font-semibold">
            {activeFilter === 'All' ? 'All Job Seekers' : `${activeFilter} Job Seekers`} 
            <span className="text-orange-500 ml-3">({filteredJobSeekers.length})</span>
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full min-w-[1100px]">
            <thead>
              <tr className="bg-gray-950 border-b border-gray-700">
                <th className="p-6 text-left">Full Name</th>
                <th className="p-6 text-left">Email</th>
                <th className="p-6 text-left cursor-pointer" onClick={() => handleSort('minimumSalary')}>
                  Minimum Salary {getSortIcon('minimumSalary')}
                </th>
                <th className="p-6 text-left cursor-pointer" onClick={() => handleSort('leastSalary')}>
                  Least Salary {getSortIcon('leastSalary')}
                </th>
                <th className="p-6 text-left">Phone</th>
                <th className="p-6 text-left">Location</th>
                <th className="p-6 text-left">Verified</th>
                <th className="p-6 text-left">Blacklisted</th>
                <th className="p-6 text-left">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredJobSeekers.map((js) => (
                <tr key={js._id} className="border-b border-gray-800 hover:bg-gray-800/70 transition-all">
                  <td className="p-6 font-medium">
                    {js.firstName} {js.middleName} {js.lastName}
                  </td>
                  <td className="p-6 text-gray-400">{js.email || 'N/A'}</td>
                  <td className="p-6 font-mono">₦{parseFloat(js.minimumSalary || 0).toLocaleString()}</td>
                  <td className="p-6 font-mono">₦{parseFloat(js.leastSalary || 0).toLocaleString()}</td>
                  <td className="p-6 text-gray-400">{js.phoneNumber || 'N/A'}</td>
                  <td className="p-6 text-sm text-gray-400">
                    {js.state} • {js.localGovernment}
                  </td>
                  <td className="p-6">
                    <span className={`px-4 py-1 rounded-full text-xs ${js.isVerified ? 'bg-green-500/20 text-green-400' : 'bg-gray-700 text-gray-400'}`}>
                      {js.isVerified ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td className="p-6">
                    <span className={`px-4 py-1 rounded-full text-xs ${js.isBlacklisted ? 'bg-red-500/20 text-red-400' : 'bg-gray-700 text-gray-400'}`}>
                      {js.isBlacklisted ? 'Yes' : 'No'}
                    </span>
                  </td>
                  <td className="p-6 flex gap-3">
                    <button
                      onClick={() => setSelectedJobSeeker(js)}
                      className="flex items-center gap-2 bg-gray-800 hover:bg-orange-600 px-5 py-2 rounded-xl text-sm transition"
                    >
                      <FaEye /> View
                    </button>
                    {localStorage.getItem('userType') === 'admin' && <AdminActions jobSeekerId={js._id} isBlacklisted={js.isBlacklisted} />}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Detailed Modal - Unchanged */}
      {selectedJobSeeker && (
        <div className="fixed inset-0 bg-black/90 z-[100] flex items-center justify-center p-4 overflow-y-auto">
          <div className="bg-gray-900 rounded-3xl max-w-4xl w-full max-h-[95vh] overflow-hidden border border-gray-700 shadow-2xl">
            <div className="flex items-center justify-between p-6 border-b border-gray-700 bg-gray-950 rounded-t-3xl">
              <div className="flex items-center gap-4">
                {selectedJobSeeker.avatar ? (
                  <img src={selectedJobSeeker.avatar} alt="Avatar" className="w-16 h-16 rounded-2xl object-cover border-2 border-orange-500" />
                ) : (
                  <FaUserCircle className="w-16 h-16 text-gray-600" />
                )}
                <div>
                  <h2 className="text-2xl font-bold">
                    {selectedJobSeeker.firstName} {selectedJobSeeker.middleName} {selectedJobSeeker.lastName}
                  </h2>
                  <p className="text-gray-400">{selectedJobSeeker.email}</p>
                </div>
              </div>
              <button
                onClick={() => setSelectedJobSeeker(null)}
                className="text-3xl text-gray-400 hover:text-white transition"
              >
                <FaTimes />
              </button>
            </div>

            <div className="p-8 overflow-y-auto max-h-[calc(95vh-80px)] grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-6">
                <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Personal Information</h3>
                <div className="grid grid-cols-2 gap-y-4 text-sm">
                  <p><strong>Phone:</strong> {selectedJobSeeker.phoneNumber || 'N/A'}</p>
                  <p><strong>Gender:</strong> {selectedJobSeeker.gender || 'N/A'}</p>
                  <p><strong>Date of Birth:</strong> {selectedJobSeeker.dateOfBirth || 'N/A'}</p>
                  <p><strong>Marital Status:</strong> {selectedJobSeeker.maritalStatus || 'N/A'}</p>
                  <p><strong>State:</strong> {selectedJobSeeker.state || 'N/A'}</p>
                  <p><strong>LGA:</strong> {selectedJobSeeker.localGovernment || 'N/A'}</p>
                  <p><strong>Country:</strong> {selectedJobSeeker.country || 'N/A'}</p>
                  <p><strong>Address:</strong> {selectedJobSeeker.address || 'N/A'}</p>
                </div>
              </div>

              <div className="space-y-6">
                <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Salary & Job Preferences</h3>
                <div className="space-y-4">
                  <div className="bg-gray-800 p-5 rounded-2xl">
                    <p className="text-gray-400 text-sm">Minimum Salary Expected</p>
                    <p className="text-3xl font-bold text-emerald-400">₦{parseFloat(selectedJobSeeker.minimumSalary || 0).toLocaleString()}</p>
                  </div>
                  <div className="bg-gray-800 p-5 rounded-2xl">
                    <p className="text-gray-400 text-sm">Least Acceptable Salary</p>
                    <p className="text-3xl font-bold text-orange-400">₦{parseFloat(selectedJobSeeker.leastSalary || 0).toLocaleString()}</p>
                  </div>
                </div>
              </div>

              <div className="md:col-span-2 space-y-6">
                <h3 className="text-xl font-semibold text-orange-400 border-b border-gray-700 pb-2">Additional Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
                  <div><strong>Is Verified:</strong> {selectedJobSeeker.isVerified ? 'Yes' : 'No'}</div>
                  <div><strong>Blacklisted:</strong> {selectedJobSeeker.isBlacklisted ? 'Yes' : 'No'}</div>
                  <div><strong>Account Balance:</strong> ₦{selectedJobSeeker.accountBalance?.toLocaleString() || 0}</div>
                  <div><strong>NIN Verified:</strong> {selectedJobSeeker.isNINVerified ? 'Yes' : 'No'}</div>
                  <div><strong>Availability for Urgent Work:</strong> {selectedJobSeeker.availabilityForUrgentWork ? 'Yes' : 'No'}</div>
                  <div><strong>Last Login:</strong> {selectedJobSeeker.lastLogin ? new Date(selectedJobSeeker.lastLogin).toLocaleString() : 'Never'}</div>
                  <div><strong>Education Level:</strong> {selectedJobSeeker.educationLevel || 'N/A'}</div>
                  <div><strong>Job Mode:</strong> {selectedJobSeeker.jobMode || 'N/A'}</div>
                </div>
              </div>
            </div>

            <div className="p-6 border-t border-gray-700 bg-gray-950 flex justify-end rounded-b-3xl">
              <button
                onClick={() => setSelectedJobSeeker(null)}
                className="px-8 py-3 bg-gray-800 hover:bg-gray-700 rounded-2xl transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobSeekerTable;